import { Price, Pricings } from '~/composables/types/event'

export const usePricingsFactory = () => {
  const nuxtApp = useNuxtApp()
  const { locale } = nuxtApp.$i18n

  const localeFormatted = computed(
    () =>
      `${locale.value.split('-')[0]}-${locale.value.split('-')[1].toUpperCase()}`
  )

  const priceFactory = (price: number): Price => {
    return {
      amount: price.toString(),
      currency: 'EUR',
      formatted: formatPriceAmount(price, localeFormatted.value, 'EUR', 2),
    }
  }

  const pricingsFactory = (
    basePrice: number,
    {
      appliedDiscount = 0,
      priceCategory = 'individual',
      totalParticipants = 1,
    }: {
      appliedDiscount?: number
      priceCategory?: string
      totalParticipants?: number
    }
  ): Pricings => ({
    price: {
      base_price: priceFactory(basePrice),
      applied_discount: priceFactory(appliedDiscount),
      total_price: priceFactory(basePrice * totalParticipants),
      price_category: priceCategory,
    },
    price_breakdown: [
      {
        title: 'ADULT',
        total_participants: totalParticipants,
        price_per_person: priceFactory(basePrice),
        total_price: priceFactory(basePrice * totalParticipants),
      },
    ],
  })

  return {
    priceFactory,
    pricingsFactory,
  }
}
